import { Checkbox as MuiCheckbox } from '@nexelem/deprecated-theme';
import { cn } from '@nexelem/utils';
import { ComponentProps } from 'react';

type CheckboxProps = ComponentProps<typeof MuiCheckbox>;

export const Checkbox = ({ className, ...props }: CheckboxProps) => (
  <MuiCheckbox
    disableRipple
    className={cn(
      'p-0 [&_svg]:fill-icon-primary [&.Mui-checked:not(.Mui-disabled)_svg]:fill-icon-focus [&.Mui-disabled_svg]:fill-icon-disabled',
      className,
    )}
    {...props}
  />
);
